module.exports = __webpack_public_path__ + "static/img/b5.4849ffcd.png";